import { Capacitor } from "@capacitor/core";
import { getBaseUrl } from "@/lib/site";
import { isExploreAppVariant } from "@/lib/platform";

const BUSINESS_APP_DEEP_LINK_SCHEME = "co.buukd.app";
const EXPLORE_APP_DEEP_LINK_SCHEME = "co.buukd.explore";

export function buildPaystackCallbackUrl(redirectPath?: string): string {
  const baseUrl = getBaseUrl().replace(/^http:/, "https:");
  const callbackUrl = new URL("/pay/return", baseUrl);

  if (redirectPath && redirectPath.startsWith("/")) {
    callbackUrl.searchParams.set("redirect", redirectPath);
  }

  if (Capacitor.isNativePlatform()) {
    const appScheme = isExploreAppVariant()
      ? EXPLORE_APP_DEEP_LINK_SCHEME
      : BUSINESS_APP_DEEP_LINK_SCHEME;
    const mobileReturnUrl = new URL(`${appScheme}://pay/return`);
    if (redirectPath && redirectPath.startsWith("/")) {
      mobileReturnUrl.searchParams.set("redirect", redirectPath);
    }
    callbackUrl.searchParams.set("mobile_redirect", mobileReturnUrl.toString());
  }

  return callbackUrl.toString();
}

